angular.module('bmsApp.settings').factory('BusinessDetailSvc', function ($http, $log, $window, $q, CRUDSvc, BUSINESS_DETAIL_API) {
    return {
        read: function () {return CRUDSvc.get(BUSINESS_DETAIL_API.READ);},
        create: function (data) {return CRUDSvc.post(BUSINESS_DETAIL_API.CREATE, data);},
        update: function (data) {return CRUDSvc.post(BUSINESS_DETAIL_API.UPDATE, data);}

    };
}).constant('BUSINESS_DETAIL_API', {
    READ: 'api/settings/businessAddress/read',
    CREATE: 'api/settings/businessAddress/create',
    UPDATE: 'api/settings/businessAddress/update'
});


